import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-12 gap-3 md:gap-4" }
const _hoisted_2 = { class: "col-span-12 xxl:col-span-12 grid grid-cols-12 gap-6" }
const _hoisted_3 = { class: "col-span-12 mt-4" }
const _hoisted_4 = { class: "intro-y flex sm:flex-row items-center h-auto sm:h-10" }
const _hoisted_5 = { class: "flex flex-col max-w-3/4" }
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "mt-1 text-xs text-gray-600" }
const _hoisted_8 = { class: "ml-auto mt-2 sm:mt-0 flex" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "hidden md:block" }, "Reload Data", -1)
const _hoisted_10 = { class: "intro-y col-span-12" }
const _hoisted_11 = { class: "box p-3" }
const _hoisted_12 = { class: "flex flex-col pb-3 mb-1 border-b border-gray-400" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-base mb-1" }, "Uraian Pertanyaan :", -1)
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-base mb-2" }, "Response :", -1)
const _hoisted_16 = { class: "overflow-y-scroll scrollbar-hidden px-0 md:px-5 pt-5 flex-1" }
const _hoisted_17 = {
  key: 0,
  class: "chat__box__text-box flex items-end float-left mb-4"
}
const _hoisted_18 = { class: "w-10 h-10 hidden sm:block flex-none image-fit relative mr-5" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "bg-gray-200 dark:bg-dark-5 px-4 py-3 text-gray-700 dark:text-gray-300 rounded-r-md rounded-t-md" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "text-base text-left font-medium" }, "Member", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "my-2 border-b border-green-500" }, null, -1)
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "mt-1 text-xs text-gray-600" }
const _hoisted_25 = {
  key: 1,
  class: "chat__box__text-box flex items-end float-right mb-4"
}
const _hoisted_26 = { class: "bg-theme-1 px-4 py-3 text-white rounded-l-md rounded-t-md" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { class: "text-base text-left font-medium" }, "You", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "my-2 border-b border-green-500" }, null, -1)
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = { class: "mt-1 text-xs text-theme-25" }
const _hoisted_31 = { class: "w-10 h-10 hidden sm:block flex-none image-fit relative ml-5" }
const _hoisted_32 = ["src"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "clear-both" }, null, -1)
const _hoisted_34 = {
  key: 0,
  class: "text-base font-bold mb-3 text-center"
}
const _hoisted_35 = { class: "flex flex-col items-center justify-center border-t border-gray-400 py-5 mt-3" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", { class: "text-base text-center font-medium mb-2" }, "Masukan Balasan", -1)
const _hoisted_37 = { class: "preview w-full md:w-3/5 mx-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RefreshCcwIcon = _resolveComponent("RefreshCcwIcon")!
  const _component_CKEditor = _resolveComponent("CKEditor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", {
              class: "text-lg font-medium truncate",
              title: _ctx.dataRC.detail.title
            }, _toDisplayString(_ctx.dataRC.detail.title), 9, _hoisted_6),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$h.formatDate(_ctx.dataRC.detail.tanggal, "DD MMM, YYYY")), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getData())),
              class: "button bg-theme-1 hover:bg-primary text-white flex"
            }, [
              _createVNode(_component_RefreshCcwIcon, { class: "w-4 h-4 mr-0 md:mr-2" }),
              _hoisted_9
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", {
            class: "text-sm",
            innerHTML: _ctx.dataRC.detail.content
          }, null, 8, _hoisted_14)
        ]),
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataRC.detail.answers, (a, idx) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
              (!a.isMentor)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("img", {
                        alt: "Midone Tailwind HTML Admin Template",
                        class: "rounded-full",
                        src: require(`@/assets/images/icon.png`)
                      }, null, 8, _hoisted_19)
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _hoisted_22,
                      _createElementVNode("div", {
                        innerHTML: a.content
                      }, null, 8, _hoisted_23),
                      _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$h.formatDate(a.tanggal, "DD MMM, YYYY HH:mm:ss")), 1)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _hoisted_27,
                      _hoisted_28,
                      _createElementVNode("div", {
                        innerHTML: a.content
                      }, null, 8, _hoisted_29),
                      _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$h.formatDate(a.tanggal, "DD MMM, YYYY HH:mm:ss")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("img", {
                        alt: "Midone Tailwind HTML Admin Template",
                        class: "rounded-full",
                        src: _ctx.photoUser
                      }, null, 8, _hoisted_32)
                    ])
                  ])),
              _hoisted_33
            ], 64))
          }), 128)),
          (_ctx.dataRC.detail.answers.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, " Belum ada Response "))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_35, [
          _hoisted_36,
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_component_CKEditor, {
              modelValue: _ctx.dataRC.contentResponse,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dataRC.contentResponse) = $event)),
              editor: _ctx.classicEditor,
              config: _ctx.editorConfig
            }, null, 8, ["modelValue", "editor", "config"])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "button whitespace-nowrap w-auto bg-theme-1 text-white mt-3",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tambahResponse()))
          }, " Simpan Balasan ")
        ])
      ])
    ])
  ]))
}